/**
 * The entry point for Adobe Analytics on DFX
 * It pulls together the DFX specific metrics and initialisation and calls the generic analytics library
 */
(function (analytics) {
    "use strict";

    /**
     * Kicks off the tracking calls
     * @function
     */
    function track() {
        //console.log("nadex analytics: track() called");

        function addPlugins() {
            //plugins are individual js files, make sure they are included in the gulpfile
            var numPlugins = analytics.plugins.length;
            if (numPlugins > 0) {
                for (var i = 0; i < numPlugins; i++) {
                    if (typeof analytics.plugins[i] === 'function') {
                        analytics.plugins[i]();
                    }
                }
            }
        }

        var config = analytics.sitecatConfig;
        var genericAnalytics = analytics.tracking = new analytics.GenericAnalytics(config);
        //remove dependancy on jQuery
        //var analyticsDeferred = genericAnalytics.initialise();
        genericAnalytics.initialise();

        analytics.sitecatalyst.usePlugins = true;
        analytics.sitecatalyst.doPlugins = addPlugins;

        //remove dependancy on jQuery
        //analyticsDeferred.always(function (genericAnalytics) {
            //console.log("nadex analytics: analyticsDeferred.always called");
            //do tracking
            genericAnalytics.triggerSiteCat();
        //}.bind(null, genericAnalytics));

    }

    track();
}(window.nadex.marketing.analytics));